// extracted by mini-css-extract-plugin
export default {"analytic_card_info":"styles_analytic_card_info__jKxRS","title":"styles_title__Az25f"};